<div class="stateroom-container">
    <!-- Warning Messages go here -->
    <div class="warning-messages-container" [ngClass]="{'tp-box': showTravelPartyBox && !checkErrors()}">
        <dcl-warning-messaging
            class="warning-message"
            configuredStyles="true"
            messageType="warning"
            [message]="'stateroom.primaryUnderAgeWarning' | translate"
            [showMessage]="errors.primaryUnderAgeWarning">
        </dcl-warning-messaging>
        <dcl-warning-messaging
            class="warning-message"
            configuredStyles="true"
            messageType="warning"
            [message]="'stateroom.accessibleRoomWarningMessage' | translate"
            [showMessage]="disableAccessibleRoom">
        </dcl-warning-messaging>
        <dcl-warning-messaging
            class="warning-message"
            configuredStyles="true"
            messageType="warning"
            [message]="'stateroom.infantRestrictionMessage' | translate"
            [showMessage]="errors.infantRestriction">
        </dcl-warning-messaging>
        <dcl-warning-messaging
            class="has-error"
            configuredStyles="true"
            messageType="warning"
            [message]="'stateroom.infantPerAdultExceededMessage' | translate"
            [showMessage]="errors.infantsPerAdultRestriction">
        </dcl-warning-messaging>
        <dcl-warning-messaging
            class="has-error"
            configuredStyles="true"
            messageType="warning"
            [message]="maxCapacityWarningMessage | translate: { url: constants.callUrl }"
            [showMessage]="childrenError">
        </dcl-warning-messaging>
        <dcl-warning-messaging
            class="warning-message"
            configuredStyles="true"
            messageType="warning"
            [message]="'stateroom.onlyOneAdultWarningMessage' | translate"
            [showMessage]="errors.onlyOneAdultWarning">
        </dcl-warning-messaging>
    </div>
    <div class="stateroom-item-wrapper" *ngIf="!showAcceptance">
        <div class="stateroom-item">
            <!-- Accessible Room Checkbox -->
            <div class="accessible-room-wrapper">
                <span class="stateroom-label" aria-hidden="true">
                    {{ 'stateroom.stateroomNumber' | translate: { stateroomIndex: (index + 1) } }}
                </span>
                <div class="accessible-room"
                    (click)="showAccessibleMessage($event)"
                    tabindex="0"
                    #accessibleRoomCheckbox
                    role="checkbox"
                    [attr.disabled]="disableAccessibleRoom || null"
                    [attr.checked]="stateroom.accessible"
                    [attr.aria-disabled]="disableAccessibleRoom || null"
                    [attr.aria-checked]="stateroom.accessible"
                    [attr.aria-label]="'stateroom.accessibleRoomAria' | translate: { stateroomIndex: (index + 1) }"
                    (keydown.enter)="showAccessibleMessage($event)"
                    (keydown.tab)="firstItemTabbed.emit($event)">
                    <wdpr-checkbox
                        aria-hidden="true"
                        tabindex="-1"
                        [checked]="stateroom.accessible"
                        [attr.disabled]="disableAccessibleRoom || null">
                        <div class="accessible-text-section">
                            <span class="accessible-room-accessible-text" translate> stateroom.accessibleRoom </span>
                            <i class="di di-accessibility accessible-icon"></i>
                        </div>
                    </wdpr-checkbox>
                </div>
            </div>
            <!--Plus-Minus RA Component-->
            <div class="counter-wrapper">
                <div class="counter-item">
                    <span
                        #adultsLabel
                        class="counter-label"
                        [ngClass]="{ 'has-error': adultsError }"
                        [attr.tabindex]="adultsError ? 0 : null"
                        [attr.aria-label]="adultsError ? adultsAriaLabel : null"
                        translate>
                        stateroom.adultsLabel
                    </span>
                    <wdpr-counter
                        class="wdpr-counter-wrapper"
                        field-name="adults"
                        [attr.minus-alt]="'stateroom.minusAltForAdults' | translate: { adults: stateroom.adultCount }"
                        [attr.counter-alt]="'stateroom.countAltForAdults' | translate: { adults: stateroom.adultCount }"
                        [attr.plus-alt]="'stateroom.plusAltForAdults' | translate: { adults: stateroom.adultCount }"
                        [attr.upper-limit]="constants.adultsUpperLimit"
                        [attr.lower-limit]="constants.adultslowerLimit"
                        [value]="stateroom.adultCount"
                        (value-changed)="$event.target.value !== 0 && updateStateroom($event, true)">
                    </wdpr-counter>
                </div>
                <div class="counter-item">
                    <span
                        #childrenLabel
                        class="counter-label"
                        [ngClass]="{ 'has-error': childrenError }"
                        [attr.tabindex]="childrenError ? 0 : null"
                        [attr.aria-label]="childrenError ? childrenAriaLabel : null"
                        translate>
                        stateroom.childsLabel
                    </span>
                    <wdpr-counter
                        class="wdpr-counter-wrapper"
                        field-name="childrens"
                        [attr.minus-alt]="'stateroom.minusAltForChilds' | translate: { childs: stateroom.childCount }"
                        [attr.counter-alt]="'stateroom.countAltForChilds' | translate: { childs: stateroom.childCount }"
                        [attr.plus-alt]="'stateroom.plusAltForChilds' | translate: { childs: stateroom.childCount}"
                        [attr.upper-limit]="constants.childsUpperLimit"
                        [value]="stateroom.childCount"
                        (value-changed)="updateStateroom($event, false)">
                    </wdpr-counter>
                </div>
            </div>
            <!-- Age selector -->
            <div class="age-selector-wrapper" *ngIf="stateroom.nonAdultAges.length > 0">
                <span
                    class="age-selector-label"
                    [ngClass]="{ 'has-error': errors.infantsPerAdultRestriction }"
                    translate>
                    stateroom.ageChildren
                </span>
                <div class="age-selector-container">
                    <wdpr-single-select
                        *ngFor="let child of stateroom.nonAdultAges; let childIndex = index"
                        #childSelectors
                        class="age-options"
                        [label]="'stateroom.childLabel' | translate: { childNumber: (childIndex + 1) }"
                        [options]="options.ages"
                        [value]="getChildAge(child)"
                        required-field="true">
                    </wdpr-single-select>
                </div>
            </div>
        </div>
        <div class="stateroom-remove-wrapper">
            <button
                class="dcl-link travel-party-remove-stateroom"
                *ngIf="checkForMoreStaterooms"
                attr.aria-label="{{ 'stateroom.removeButton' | translate }}"
                (click)="removeStateroom($event, stateroom)"
                translate
                (keydown.Tab)="lastItemTabbed.emit($event)">
                stateroom.removeButton
            </button>
        </div>
    </div>
    <div class="accessible-container" *ngIf="showAcceptance">
        <span class="accessible-stateroom-label">{{ 'stateroom.stateroomNumber' | translate: { stateroomIndex: (index + 1) } }}</span>
        <div class="accessible-content">
            <div class="accessible-info" translate>
                stateroom.accessibleInfo
            </div>
            <div class="accessible-options">
                <button class="cancel-accessible dcl-link"
                    attr.aria-label="{{ 'stateroom.accessibleCancelAria' | translate }}"
                    (click)="addAccessible($event, false)"
                    translate>
                    stateroom.accessibleCancel
                </button>
                <wdpr-button
                    class="confirm-accessible"
                    theme="secondary"
                    (click)="addAccessible($event, true)"
                    (touchstart)="addAccessible($event, true)"
                    attr.aria-label="{{ 'stateroom.accessibleConfirmAria' | translate }}"
                    (keydown.tab)="lastItemTabbed.emit($event)">
                    <span>{{ 'stateroom.accessibleConfirm' | translate }}</span>
                </wdpr-button>
            </div>
        </div>
    </div>
</div>
